<template>
  <v-app>
    <!-- Splash -->
    <div class="splash-screen">
      <div class="d-flex flex-row align-center mb-5">
        <v-img
          :src="require('@/assets/logo.png')"
          :max-width="logoMaxWidth"
          contain
        ></v-img>

        <v-img
          :src="require('@/assets/grandmother.png')"
          :max-width="logoMaxWidth"
          contain
        ></v-img>
      </div>

      <!-- Barra de progresso -->
      <v-progress-linear
        class="progress-bar"
        :value="progress"
        color="#c97c7c"
        rounded
        striped
      ></v-progress-linear>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "SplashScreen",
  data() {
    return {
      showSplash: true,
      progress: 0,
    };
  },
  computed: {
    logoMaxWidth() {
      // usa $vuetify.breakpoint.smAndDown para detectar mobile
      return this.$vuetify.breakpoint.smAndDown ? 150 : 250;
    },
  },
  mounted() {
    const interval = setInterval(() => {
      if (this.progress < 100) {
        this.progress += 3; // aumenta até 100
      } else {
        clearInterval(interval);
        this.showSplash = false;
      }
    }, 60); // 60ms * 50 ~ 3 segundos
  },
};
</script>

<style>
.progress-bar {
  width: 40%;
  height: 10px !important;
}
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fec154; /* cor de fundo do splash */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}
</style>
